import { Div } from '../../../base/components/native/div'
import { Img } from '../../../base/components/native/img'
import { CENTER, EASE } from '../../../base/helpers/style'

export const Logo = () => {

    const base = Div()
    const img =  Img('/images/helloprint.webp', {height: 28})
    const line = Div('AI')
    base.append(img, line)

    img.cssClass({
        width: '100%',
    })
    line.cssClass({
        ...CENTER,
        fontFamily: 'Roboto',
        fontWeight: '700',
        fontSize: '26px',
        borderLeft: '1px solid #ffffff',
        paddingTop: '2px',
        paddingLeft: '14px',
        marginLeft: '14px',
        height: '28px'
    })

 
    base.cssClass({
        color: '#fff',
        width: '153px',
        margin: '15px auto 0',
        ...EASE(.24),
        ...CENTER,
        '&.dark': {
            color: '#fff'
        }
    })

    return base
}